import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"]

  abortController = undefined

  resetOrStartAbortController(){
    if(this.abortController){
      delete this.abortController;
    }

    this.abortController = new AbortController();
  }

  toggleMenu() {
    if (this.menuTarget.classList.contains('hidden')){
      this.resetOrStartAbortController()

      document.addEventListener(
        'click',
        (e) => {
          if (!this.element.contains(e.target)){
            this.toggleMenu();
          }
        },
        {
          signal: this.abortController.signal,
        },
      );
      this.menuTarget.classList.replace('hidden', 'flex');
    } else {
      this.abortController.abort('Clicked Outside');
      this.menuTarget.classList.replace('flex', 'hidden');
    }
  }
}
